import React from 'react'
import './footer.css'
import {FaTwitter,FaLinkedin,FaTelegramPlane} from 'react-icons/fa'

function Footer() {
  return (
    <footer>
      <a href="#home" className='footer_logo'>NOOR ALAM</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
        
      </ul>
      <div className="footer_social">
        <a href="https://twitter.com/nooralam619" target='_blank'  rel="noreferrer"><FaTwitter className='icon'/></a>
        <a href="https://www.linkedin.com/in/noor-alam-aa722314b/" target='_blank'  rel="noreferrer"><FaLinkedin  className='icon'/></a>
        <a href="https://t.me/Noordna" target='_blank'  rel="noreferrer"><FaTelegramPlane className='icon'/></a>
      </div>
      <div className="footer_copyright">
        <small>&copy; Noor ALam | All Right Reserved</small>
      </div>
    </footer>
  )
}

export default Footer